import React from 'react';
import PropTypes from 'prop-types';
import StrapiPrivacy from '../../molecules/strapi-privacy';

const Privacy = (props) => <StrapiPrivacy {...props.data} />;

Privacy.propTypes = {
  data: PropTypes.object.isRequired
};

Privacy.whyDidYouRender = true;

export default Privacy;
